import { Component, type ReactNode } from 'react';

// Catches render/runtime errors so ONE bad record (or any component throw) shows a
// fallback instead of white-screening the whole SPA — React unmounts the entire tree
// on an uncaught throw during render, leaving a blank <div id="root">.
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: unknown) {
    // Keep the app alive; surface for debugging.
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <main style={{ fontFamily: 'system-ui, sans-serif', maxWidth: 560, margin: '4rem auto', padding: '0 1.25rem', textAlign: 'center' }}>
          <h1 style={{ color: '#1a4480', fontSize: '1.4rem', margin: 0 }}>Something went wrong</h1>
          <p style={{ color: '#4b5563', lineHeight: 1.6, marginTop: '0.75rem' }}>
            We hit a snag loading this page. Please try refreshing — if it keeps happening, it’ll be fixed shortly.
          </p>
          <div style={{ marginTop: '1.25rem', display: 'flex', gap: '0.6rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button onClick={() => window.location.reload()} style={{ padding: '0.6rem 1.2rem', background: '#1a4480', color: 'white', border: 'none', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>Refresh</button>
            <a href="/updates" style={{ padding: '0.6rem 1.2rem', background: 'white', color: '#1a4480', border: '1px solid #1a4480', borderRadius: 8, fontWeight: 600, textDecoration: 'none' }}>Latest updates</a>
          </div>
        </main>
      );
    }
    return this.props.children;
  }
}
